import React from 'react';
import MyButton from '../../../components/MyButton';
import MyCheckBox from '../../../components/MyCheckbox';
import { isAllCitiesSelection } from '../../../helpers/allCitiesOfCountry';
import { CONTACT_FIELDS, EVENT_STATUSES } from '../../../helpers/eventsBulkAutofill';
import { formatHoldingDatesList } from '../../../helpers/formatHoldingDatesList';

const STATUS_LABELS = {
  [EVENT_STATUSES.creating]: 'Создаётся…',
  [EVENT_STATUSES.created]: 'Создано',
  [EVENT_STATUSES.error]: 'Ошибка',
};

function Row({ label, value }) {
  if (value === null || value === undefined || value === '') return null;
  return (
    <div className="bulk_offers_card_row">
      <p className="bulk_offers_card_row_label">{label}</p>
      <p className="bulk_offers_card_row_value">{value}</p>
    </div>
  );
}

function EventCard({
  draft,
  index,
  errors = [],
  isSelected,
  onToggleSelect,
  onCreate,
  onRemove,
  onEdit,
}) {
  const isCreated = draft.status === EVENT_STATUSES.created;
  const isCreating = draft.status === EVENT_STATUSES.creating;
  const cityText = isAllCitiesSelection(draft.city)
    ? `Все города — ${draft.city?.country?.name || ''}`
    : draft.city?.name || '';
  const datesText = formatHoldingDatesList(
    (draft.holdingDates || []).filter(Boolean).map((day) => (
      draft.holdingTime ? `${day}T${draft.holdingTime}:00.000Z` : day
    )),
  );
  const contactsText = CONTACT_FIELDS
    .filter(({ key }) => draft.contacts?.[key])
    .map(({ key, label }) => `${label}: ${draft.contacts[key]}`)
    .join('\n');

  return (
    <div className={`bulk_offers_card ${isSelected ? 'selected' : ''} ${isCreated ? 'created' : ''} ${draft.status === EVENT_STATUSES.error ? 'failed' : ''}`}>
      <div className="bulk_offers_card_head">
        <MyCheckBox
          value={isSelected}
          onClick={onToggleSelect}
          disabled={isCreated || isCreating}
          wrapperClassName="bulk_offers_card_checkbox"
        />
        <p className="bulk_offers_card_index">{`#${index + 1}`}</p>
        {STATUS_LABELS[draft.status] ? (
          <p className={`bulk_offers_card_status ${draft.status}`}>{STATUS_LABELS[draft.status]}</p>
        ) : errors.length ? (
          <p className="bulk_offers_card_status invalid">{`${errors.length} — не готово`}</p>
        ) : (
          <p className="bulk_offers_card_status ready">Готово к созданию</p>
        )}
      </div>

      <p className="bulk_offers_card_name">{draft.name || 'Без названия'}</p>

      <div className="bulk_offers_card_body">
        <Row label="Категория" value={draft.category?.name} />
        <Row label="Даты" value={datesText} />
        <Row label="Город" value={cityText} />
        <Row label="Адрес" value={draft.address} />
        <Row label="Координаты" value={draft.coordinates?.lat ? `${draft.coordinates.lat}, ${draft.coordinates.lon}` : ''} />
        <Row label="Контакты" value={contactsText} />
        <Row label="Описание" value={draft.description} />
        <Row label="Для всех языков" value={draft.is_for_all_languages ? 'Да' : 'Нет'} />
        <Row label="Языки" value={draft.languages?.map((item) => item.name).join(', ')} />
        <Row
          label="Фото"
          value={draft.photos?.length
            ? `${draft.photos.filter((item) => item.file).length} файл / ${draft.photos.filter((item) => item.url).length} ссылка`
            : ''}
        />
        <Row label="ID владельца" value={draft.ownerId} />

        {draft.warnings?.length ? (
          <ul className="bulk_offers_card_warnings">
            {draft.warnings.map((warning) => <li key={warning}>{warning}</li>)}
          </ul>
        ) : null}
        {draft.statusText ? <p className="bulk_offers_card_error_text">{draft.statusText}</p> : null}
        {!isCreated && errors.length ? (
          <ul className="bulk_offers_card_errors">
            {errors.map((error) => <li key={error}>{error.replace(/^\s*\*\s*/, '')}</li>)}
          </ul>
        ) : null}
      </div>

      <div className="bulk_offers_card_actions">
        <MyButton
          text="Создать"
          onClick={onCreate}
          loading={isCreating}
          disabled={isCreated || Boolean(errors.length)}
          className="bulk_offers_card_button"
        />
        <MyButton text="Изменить" onClick={onEdit} secondary disabled={isCreated} className="bulk_offers_card_button" />
        <MyButton text="Убрать" onClick={onRemove} secondary className="bulk_offers_card_button bulk_offers_card_button_remove" />
      </div>
    </div>
  );
}

export default EventCard;
